<template>
  <div class="layout_content_sidebar">
    <el-menu class="my-el-menu-no-border" :router="true" :default-active="defaultActive">
      <!-- 超过默认页 -->
      <el-menu-item index="/home/products" v-if="isBoss">
        <template slot="title">商品管理</template>
      </el-menu-item>
      <el-menu-item index="/home/coupons" v-if="isBoss">
        <template slot="title">优惠券管理</template>
      </el-menu-item>
      <el-menu-item index="/home/brands" v-if="isSuper">
        <template slot="title">品牌管理</template>
      </el-menu-item>
      <el-menu-item index="/home/shops" v-if="isBoss">
        <template slot="title">门店管理</template>
      </el-menu-item>
      <el-menu-item index="/home/clerks" v-if="isBoss">
        <template slot="title">店员管理</template>
      </el-menu-item>
      <el-menu-item index="/home/banners" v-if="isSuper">
        <template slot="title">首页Banner管理</template>
      </el-menu-item>
      <el-menu-item index="/home/camera" v-if="isSuper">
        <template slot="title">摄像头管理</template>
      </el-menu-item>
      <el-menu-item index="/home/statistics" v-if="isBoss">
        <template slot="title">数据统计</template>
      </el-menu-item>
      <el-menu-item index="/home/account" v-if="isSuper">
        <template slot="title">账号管理</template>
      </el-menu-item>
      <el-menu-item index="/home/user" v-if="isSuper">
        <template slot="title">客户查询</template>
      </el-menu-item>
      <el-menu-item index="/home/shopHistory">
        <template slot="title">门店浏览记录</template>
      </el-menu-item>
    </el-menu>
  </div>
</template>
<script>
export default {
  computed: {
    // 当前path地址
    defaultActive () {
      return this.$route.path
    },
    // 用户身份
    role () {
      // 用户详细信息
      return this.$store.state.userInfo.role
    },
    // 是否是超级管理员
    isSuper () {
      return this.role === 'super'
    },
    // 是否是老板
    isBoss () {
      return this.role === 'boss'
    }
  }
}
</script>
<style lang="scss" scoped>
  .layout_content_sidebar {
    width: $layout-sidebar-width;
    height: 100%;
    background-color: $color-white;
    padding-top: 10px;
    box-shadow:0px 0px 4px rgba(0,0,0,0.1);
    z-index: 95;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/content/sidebar/index.vue